import { EditorObject } from 'utils/responsiveTypes'

const dashboardMetricBoxes: EditorObject = {
  x: 0,
  y: 20,
  id: 'egxurzxpi4eaadl13xye9mduh',
  name: 'Section 23',
  type: 'LAYOUT_SECTION',
  width: 1512,
  height: 1031,
  hidden: false,
  mobile: {
    x: 0,
    y: 20,
    width: 1512,
    height: 433,
    pushGraph: {
      edges: [],
      nodeIds: ['6d0gng1qpvhk2hkyfyq4ru57l'],
    },
    positioning: 'fixedTop',
    responsivity: {
      verticalScaling: 'FIXED',
      horizontalScaling: 'SCALES_WITH_PARENT',
      verticalPositioning: 'TOP',
      horizontalPositioning: 'CENTER',
    },
  },
  shadow: {
    x: 0,
    y: 2,
    size: 4,
    color: '#00000020',
    enabled: true,
  },
  shared: {
    mobile: false,
    tablet: false,
    desktop: false,
  },
  tablet: {
    x: 0,
    y: 20,
    width: 1512,
    height: 282,
    pushGraph: {
      edges: [],
      nodeIds: ['6d0gng1qpvhk2hkyfyq4ru57l'],
    },
    positioning: 'fixedTop',
    responsivity: {
      verticalScaling: 'FIXED',
      horizontalScaling: 'SCALES_WITH_PARENT',
      verticalPositioning: 'TOP',
      horizontalPositioning: 'CENTER',
    },
  },
  actions: {},
  desktop: {
    x: 0,
    y: 20,
    width: 1512,
    height: 271,
    pushGraph: {
      edges: [],
      nodeIds: ['6d0gng1qpvhk2hkyfyq4ru57l'],
    },
    positioning: 'fixedTop',
    responsivity: {
      verticalScaling: 'FIXED',
      horizontalScaling: 'SCALES_WITH_PARENT',
      verticalPositioning: 'TOP',
      horizontalPositioning: 'CENTER',
    },
  },
  opacity: 1,
  children: [
    {
      x: 0,
      y: 35,
      id: '6d0gng1qpvhk2hkyfyq4ru57l',
      name: 'Layout Helper',
      type: 'section',
      width: 1512,
      height: 1001,
      hidden: false,
      mobile: {
        x: 0,
        y: 35,
        width: 1512,
        height: 403,
        pushGraph: {
          edges: [],
          nodeIds: ['9d8gljssqqz83i5zeg2wwrp91'],
        },
        positioning: 'fixed',
        responsivity: {
          verticalScaling: 'FIXED',
          horizontalScaling: 'SCALES_WITH_PARENT',
          verticalPositioning: 'TOP',
          horizontalPositioning: 'CENTER',
        },
      },
      shadow: {
        x: 0,
        y: 2,
        size: 4,
        color: 'rgba(0, 0, 0, 0.2)',
        enabled: false,
      },
      shared: {
        mobile: false,
        tablet: false,
        desktop: false,
      },
      tablet: {
        x: 0,
        y: 35,
        width: 1512,
        height: 252,
        pushGraph: {
          edges: [],
          nodeIds: ['9d8gljssqqz83i5zeg2wwrp91'],
        },
        positioning: 'fixed',
        responsivity: {
          verticalScaling: 'FIXED',
          horizontalScaling: 'SCALES_WITH_PARENT',
          verticalPositioning: 'TOP',
          horizontalPositioning: 'CENTER',
        },
      },
      actions: {},
      desktop: {
        x: 0,
        y: 35,
        width: 1512,
        height: 241,
        pushGraph: {
          edges: [],
          nodeIds: ['9d8gljssqqz83i5zeg2wwrp91'],
        },
        positioning: 'fixed',
        responsivity: {
          verticalScaling: 'FIXED',
          horizontalScaling: 'SCALES_WITH_PARENT',
          verticalPositioning: 'TOP',
          horizontalPositioning: 'CENTER',
        },
      },
      opacity: 1,
      purpose: 'layout_helper',
      children: [
        {
          x: 16,
          y: 35,
          id: '9d8gljssqqz83i5zeg2wwrp91',
          name: 'Container',
          type: 'section',
          width: 1480,
          height: 1001,
          hidden: false,
          mobile: {
            x: 62.030769230769344,
            y: 35,
            width: 1387.9384615384615,
            height: 403,
            pushGraph: {
              edges: [
                {
                  distance: 26.5,
                  endNodeId: '6z6edi3x8sjpen0jgiidv1awb',
                  startNodeId: '0nmnql1vsm1u9ydvm78je8l5j',
                },
                {
                  distance: 27,
                  endNodeId: '88eyvwcazd6dw11ayr35eg05u',
                  startNodeId: '0nmnql1vsm1u9ydvm78je8l5j',
                },
                {
                  distance: 11,
                  endNodeId: '7i34i49qwjekuf6qg9894q5ld',
                  startNodeId: '88eyvwcazd6dw11ayr35eg05u',
                },
                {
                  distance: 11.5,
                  endNodeId: 'efu7hue18uz8e01fsb2pvifem',
                  startNodeId: '6z6edi3x8sjpen0jgiidv1awb',
                },
              ],
              nodeIds: [
                '0nmnql1vsm1u9ydvm78je8l5j',
                '6z6edi3x8sjpen0jgiidv1awb',
                '88eyvwcazd6dw11ayr35eg05u',
                '7i34i49qwjekuf6qg9894q5ld',
                'efu7hue18uz8e01fsb2pvifem',
              ],
            },
            positioning: 'fixedTop',
            responsivity: {
              verticalScaling: 'FIXED',
              horizontalScaling: 'SCALES_WITH_PARENT',
              verticalPositioning: 'TOP',
              horizontalPositioning: 'CENTER',
            },
          },
          shadow: {
            x: 0,
            y: 2,
            size: 4,
            color: '#00000020',
            enabled: true,
          },
          shared: {
            mobile: false,
            tablet: false,
            desktop: false,
          },
          tablet: {
            x: 192.1726618705036,
            y: 35,
            width: 1127.6546762589928,
            height: 252,
            pushGraph: {
              edges: [
                {
                  distance: 26.5,
                  endNodeId: '88eyvwcazd6dw11ayr35eg05u',
                  startNodeId: '0nmnql1vsm1u9ydvm78je8l5j',
                },
                {
                  distance: 26.5,
                  endNodeId: '7i34i49qwjekuf6qg9894q5ld',
                  startNodeId: '0nmnql1vsm1u9ydvm78je8l5j',
                },
                {
                  distance: 26.5,
                  endNodeId: '6z6edi3x8sjpen0jgiidv1awb',
                  startNodeId: '0nmnql1vsm1u9ydvm78je8l5j',
                },
                {
                  distance: 27,
                  endNodeId: 'efu7hue18uz8e01fsb2pvifem',
                  startNodeId: '0nmnql1vsm1u9ydvm78je8l5j',
                },
              ],
              nodeIds: [
                '0nmnql1vsm1u9ydvm78je8l5j',
                '88eyvwcazd6dw11ayr35eg05u',
                '7i34i49qwjekuf6qg9894q5ld',
                '6z6edi3x8sjpen0jgiidv1awb',
                'efu7hue18uz8e01fsb2pvifem',
              ],
            },
            positioning: 'fixedTop',
            responsivity: {
              verticalScaling: 'FIXED',
              horizontalScaling: 'SCALES_WITH_PARENT',
              verticalPositioning: 'TOP',
              horizontalPositioning: 'CENTER',
            },
          },
          actions: {},
          desktop: {
            x: 261.0004999999999,
            y: 35,
            width: 990.0000000000002,
            height: 241,
            pushGraph: {
              edges: [
                {
                  distance: 26.5,
                  endNodeId: '88eyvwcazd6dw11ayr35eg05u',
                  startNodeId: '0nmnql1vsm1u9ydvm78je8l5j',
                },
                {
                  distance: 26.5,
                  endNodeId: '7i34i49qwjekuf6qg9894q5ld',
                  startNodeId: '0nmnql1vsm1u9ydvm78je8l5j',
                },
                {
                  distance: 26.5,
                  endNodeId: '6z6edi3x8sjpen0jgiidv1awb',
                  startNodeId: '0nmnql1vsm1u9ydvm78je8l5j',
                },
                {
                  distance: 26.5,
                  endNodeId: 'efu7hue18uz8e01fsb2pvifem',
                  startNodeId: '0nmnql1vsm1u9ydvm78je8l5j',
                },
              ],
              nodeIds: [
                '0nmnql1vsm1u9ydvm78je8l5j',
                '88eyvwcazd6dw11ayr35eg05u',
                '7i34i49qwjekuf6qg9894q5ld',
                '6z6edi3x8sjpen0jgiidv1awb',
                'efu7hue18uz8e01fsb2pvifem',
              ],
            },
            positioning: 'fixedTop',
            responsivity: {
              verticalScaling: 'FIXED',
              horizontalScaling: 'SCALES_WITH_PARENT',
              verticalPositioning: 'TOP',
              horizontalPositioning: 'CENTER',
            },
          },
          opacity: 1,
          purpose: 'container',
          children: [
            {
              x: 42.00000000000365,
              y: 115.5,
              id: '88eyvwcazd6dw11ayr35eg05u',
              name: 'Rectangle  35',
              type: 'section',
              width: 320.0000000000025,
              height: 144,
              hidden: false,
              mobile: {
                x: 95.3120582120589,
                y: 116,
                width: 620.3076923076904,
                height: 144,
                pushGraph: {
                  edges: [
                    {
                      distance: 3,
                      endNodeId: '6tydaz0xzb6kzy03y0ni1opbt',
                      startNodeId: '9o3x6s4fw1ebky4j66z2350mz',
                    },
                  ],
                  nodeIds: [
                    '9o3x6s4fw1ebky4j66z2350mz',
                    '6tydaz0xzb6kzy03y0ni1opbt',
                  ],
                },
                positioning: 'fixedTop',
                responsivity: {
                  verticalScaling: 'FIXED',
                  horizontalScaling: 'SCALES_WITH_PARENT',
                  verticalPositioning: 'TOP',
                  horizontalPositioning: 'CENTER',
                },
              },
              shadow: {
                x: 0,
                y: 2,
                size: 4,
                color: 'rgba(0, 0, 0, 0.2)',
                enabled: true,
              },
              shared: {
                mobile: false,
                tablet: true,
                desktop: true,
              },
              tablet: {
                x: 211.98281158856975,
                y: 115.5,
                width: 243.81722729924354,
                height: 144,
                pushGraph: {
                  edges: [
                    {
                      distance: 6,
                      endNodeId: '6tydaz0xzb6kzy03y0ni1opbt',
                      startNodeId: '9o3x6s4fw1ebky4j66z2350mz',
                    },
                  ],
                  nodeIds: [
                    '9o3x6s4fw1ebky4j66z2350mz',
                    '6tydaz0xzb6kzy03y0ni1opbt',
                  ],
                },
              },
              actions: {},
              desktop: {
                x: 278.3923918918942,
                y: 115.5,
                width: 214.05405405405577,
                height: 144,
                pushGraph: {
                  edges: [
                    {
                      distance: 4,
                      endNodeId: '6tydaz0xzb6kzy03y0ni1opbt',
                      startNodeId: '9o3x6s4fw1ebky4j66z2350mz',
                    },
                  ],
                  nodeIds: [
                    '9o3x6s4fw1ebky4j66z2350mz',
                    '6tydaz0xzb6kzy03y0ni1opbt',
                  ],
                },
              },
              opacity: 1,
              children: [
                {
                  x: 62.67415730337472,
                  y: 161,
                  id: '9o3x6s4fw1ebky4j66z2350mz',
                  name: null,
                  text: '$5,987',
                  type: 'label',
                  color: '@text',
                  width: 280.4494382022487,
                  height: 30,
                  hidden: false,
                  mobile: {
                    x: 135.38811698474692,
                    y: 162,
                    width: 543.6404494381986,
                    height: 30,
                    positioning: 'fixed',
                    responsivity: {
                      verticalScaling: 'FIXED',
                      horizontalScaling: 'SCALES_WITH_PARENT',
                      verticalPositioning: 'TOP',
                      horizontalPositioning: 'CENTER',
                    },
                  },
                  shared: {
                    mobile: false,
                    tablet: false,
                    desktop: false,
                  },
                  tablet: {
                    x: 227.73504818374542,
                    y: 160,
                    width: 213.68251381281974,
                    height: 30,
                    positioning: 'fixed',
                    responsivity: {
                      verticalScaling: 'FIXED',
                      horizontalScaling: 'SCALES_WITH_PARENT',
                      verticalPositioning: 'TOP',
                      horizontalPositioning: 'CENTER',
                    },
                  },
                  actions: {},
                  desktop: {
                    x: 292.2217268580409,
                    y: 161,
                    width: 187.59793501366647,
                    height: 30,
                    positioning: 'fixed',
                    responsivity: {
                      verticalScaling: 'FIXED',
                      horizontalScaling: 'SCALES_WITH_PARENT',
                      verticalPositioning: 'TOP',
                      horizontalPositioning: 'CENTER',
                    },
                  },
                  opacity: 1,
                  children: [],
                  fontSize: 26,
                  autoWidth: false,
                  fontStyle: 'normal',

                  multiline: true,
                  fontFamily: '@body',
                  layoutText: ['$5,987'],
                  selectable: false,
                  positioning: 'fixed',
                  responsivity: {
                    verticalScaling: 'FIXED',
                    horizontalScaling: 'SCALES_WITH_PARENT',
                    verticalPositioning: 'TOP',
                    horizontalPositioning: 'CENTER',
                  },
                  initialDevice: 'desktop',
                  textAlignment: 'center',
                  inResponsiveApp: true,
                  calculatedFontFamily:
                    '-apple-system, "SF Pro Text", sans-serif',
                },
                {
                  x: 71.26829268293044,
                  y: 195,
                  id: '6tydaz0xzb6kzy03y0ni1opbt',
                  name: null,
                  text: 'MRR TODAY',
                  type: 'label',
                  color: 'rgba(117, 117, 117, 1)',
                  width: 261.4634146341494,
                  height: 19,
                  hidden: false,
                  mobile: {
                    x: 111.36507473569108,
                    y: 195,
                    width: 588.7227123587313,
                    height: 19,
                    positioning: 'fixed',
                    responsivity: {
                      verticalScaling: 'FIXED',
                      horizontalScaling: 'SCALES_WITH_PARENT',
                      verticalPositioning: 'TOP',
                      horizontalPositioning: 'CENTER',
                    },
                  },
                  shared: {
                    mobile: false,
                    tablet: false,
                    desktop: false,
                  },
                  tablet: {
                    x: 217.2124670860554,
                    y: 196,
                    width: 233.1292209723791,
                    height: 19,
                    positioning: 'fixed',
                    responsivity: {
                      verticalScaling: 'FIXED',
                      horizontalScaling: 'SCALES_WITH_PARENT',
                      verticalPositioning: 'TOP',
                      horizontalPositioning: 'CENTER',
                    },
                  },
                  actions: {},
                  desktop: {
                    x: 297.970506583577,
                    y: 195,
                    width: 174.8978246539233,
                    height: 19,
                    positioning: 'fixed',
                    responsivity: {
                      verticalScaling: 'FIXED',
                      horizontalScaling: 'SCALES_WITH_PARENT',
                      verticalPositioning: 'TOP',
                      horizontalPositioning: 'CENTER',
                    },
                  },
                  opacity: 1,
                  children: [],
                  fontSize: 16,
                  autoWidth: false,
                  fontStyle: 'normal',

                  multiline: true,
                  fontFamily: '@body',
                  layoutText: ['MRR TODAY'],
                  selectable: false,
                  positioning: 'fixed',
                  responsivity: {
                    verticalScaling: 'FIXED',
                    horizontalScaling: 'SCALES_WITH_PARENT',
                    verticalPositioning: 'TOP',
                    horizontalPositioning: 'CENTER',
                  },
                  initialDevice: 'desktop',
                  textAlignment: 'center',
                },
              ],
              pushGraph: {
                edges: [
                  {
                    distance: 4,
                    endNodeId: '6tydaz0xzb6kzy03y0ni1opbt',
                    startNodeId: '9o3x6s4fw1ebky4j66z2350mz',
                  },
                ],
                nodeIds: [
                  '9o3x6s4fw1ebky4j66z2350mz',
                  '6tydaz0xzb6kzy03y0ni1opbt',
                ],
              },
              borderColor: '#e0e0e0',
              borderStyle: 'solid',
              borderWidth: 1,
              positioning: 'fixedTop',
              borderRadius: 12,
              responsivity: {
                verticalScaling: 'FIXED',
                horizontalScaling: 'SCALES_WITH_PARENT',
                verticalPositioning: 'TOP',
                horizontalPositioning: 'CENTER',
              },
              initialDevice: 'desktop',
              borderPosition: 'center',
              backgroundColor: '@background',
              backgroundStyle: 'color',
            },
            {
              x: 777.0000000000033,
              y: 115.5,
              id: '7i34i49qwjekuf6qg9894q5ld',
              name: 'Rectangle  36',
              type: 'section',
              width: 322.99999999999636,
              height: 144,
              hidden: false,
              mobile: {
                x: 95.3120582120589,
                y: 271,
                width: 620.3076923076904,
                height: 144,
                pushGraph: {
                  edges: [
                    {
                      distance: 3,
                      endNodeId: '61zllid8z6t7cthkp5zex5cb8',
                      startNodeId: '3adlpgk4i7v28rsnxli0po4yp',
                    },
                  ],
                  nodeIds: [
                    '3adlpgk4i7v28rsnxli0po4yp',
                    '61zllid8z6t7cthkp5zex5cb8',
                  ],
                },
                positioning: 'fixed',
                responsivity: {
                  verticalScaling: 'FIXED',
                  horizontalScaling: 'SCALES_WITH_PARENT',
                  verticalPositioning: 'TOP',
                  horizontalPositioning: 'CENTER',
                },
              },
              shadow: {
                x: 0,
                y: 2,
                size: 4,
                color: 'rgba(0, 0, 0, 0.2)',
                enabled: true,
              },
              shared: {
                mobile: false,
                tablet: true,
                desktop: true,
              },
              tablet: {
                x: 772.0005055415153,
                y: 115.5,
                width: 246.1030138051692,
                height: 144,
                pushGraph: {
                  edges: [
                    {
                      distance: 3.5,
                      endNodeId: '61zllid8z6t7cthkp5zex5cb8',
                      startNodeId: '3adlpgk4i7v28rsnxli0po4yp',
                    },
                  ],
                  nodeIds: [
                    '3adlpgk4i7v28rsnxli0po4yp',
                    '61zllid8z6t7cthkp5zex5cb8',
                  ],
                },
              },
              actions: {},
              desktop: {
                x: 770.0477972972994,
                y: 115.5,
                width: 216.06081081080833,
                height: 144,
                pushGraph: {
                  edges: [
                    {
                      distance: 4,
                      endNodeId: '61zllid8z6t7cthkp5zex5cb8',
                      startNodeId: '3adlpgk4i7v28rsnxli0po4yp',
                    },
                  ],
                  nodeIds: [
                    '3adlpgk4i7v28rsnxli0po4yp',
                    '61zllid8z6t7cthkp5zex5cb8',
                  ],
                },
              },
              opacity: 1,
              children: [
                {
                  x: 797.8679775280933,
                  y: 161,
                  id: '3adlpgk4i7v28rsnxli0po4yp',
                  name: null,
                  text: '65',
                  type: 'label',
                  color: '@text',
                  width: 283.0786516853949,
                  height: 30,
                  hidden: false,
                  mobile: {
                    x: 135.38811698474748,
                    y: 317,
                    width: 543.6404494382076,
                    height: 30,
                    positioning: 'fixed',
                    responsivity: {
                      verticalScaling: 'FIXED',
                      horizontalScaling: 'SCALES_WITH_PARENT',
                      verticalPositioning: 'TOP',
                      horizontalPositioning: 'CENTER',
                    },
                  },
                  shared: {
                    mobile: false,
                    tablet: false,
                    desktop: false,
                  },
                  tablet: {
                    x: 787.9004193547711,
                    y: 161.5,
                    width: 215.685787379814,
                    height: 30,
                    positioning: 'fixed',
                    responsivity: {
                      verticalScaling: 'FIXED',
                      horizontalScaling: 'SCALES_WITH_PARENT',
                      verticalPositioning: 'TOP',
                      horizontalPositioning: 'CENTER',
                    },
                  },
                  actions: {},
                  desktop: {
                    x: 784.0067822591454,
                    y: 161,
                    width: 189.35666565441505,
                    height: 30,
                    positioning: 'fixed',
                    responsivity: {
                      verticalScaling: 'FIXED',
                      horizontalScaling: 'SCALES_WITH_PARENT',
                      verticalPositioning: 'TOP',
                      horizontalPositioning: 'CENTER',
                    },
                  },
                  opacity: 1,
                  children: [],
                  fontSize: 26,
                  autoWidth: false,
                  fontStyle: 'normal',

                  multiline: true,
                  fontFamily: '@body',
                  layoutText: ['65'],
                  selectable: false,
                  positioning: 'fixed',
                  responsivity: {
                    verticalScaling: 'FIXED',
                    horizontalScaling: 'SCALES_WITH_PARENT',
                    verticalPositioning: 'TOP',
                    horizontalPositioning: 'CENTER',
                  },
                  initialDevice: 'desktop',
                  textAlignment: 'center',
                  inResponsiveApp: true,
                  calculatedFontFamily:
                    '-apple-system, "SF Pro Text", sans-serif',
                },
                {
                  x: 806.5426829268312,
                  y: 195,
                  id: '61zllid8z6t7cthkp5zex5cb8',
                  name: null,
                  text: ' NEW SALES',
                  type: 'label',
                  color: 'rgba(117, 117, 117, 1)',
                  width: 263.91463414633887,
                  height: 19,
                  hidden: false,
                  mobile: {
                    x: 108.07612103536285,
                    y: 350,
                    width: 595.3006197593867,
                    height: 19,
                    positioning: 'fixed',
                    responsivity: {
                      verticalScaling: 'FIXED',
                      horizontalScaling: 'SCALES_WITH_PARENT',
                      verticalPositioning: 'TOP',
                      horizontalPositioning: 'CENTER',
                    },
                  },
                  shared: {
                    mobile: false,
                    tablet: false,
                    desktop: false,
                  },
                  tablet: {
                    x: 778.449480538081,
                    y: 195,
                    width: 233.12922097237873,
                    height: 19,
                    positioning: 'fixed',
                    responsivity: {
                      verticalScaling: 'FIXED',
                      horizontalScaling: 'SCALES_WITH_PARENT',
                      verticalPositioning: 'TOP',
                      horizontalPositioning: 'CENTER',
                    },
                  },
                  actions: {},
                  desktop: {
                    x: 789.8094568188772,
                    y: 195,
                    width: 176.53749176005,
                    height: 19,
                    positioning: 'fixed',
                    responsivity: {
                      verticalScaling: 'FIXED',
                      horizontalScaling: 'SCALES_WITH_PARENT',
                      verticalPositioning: 'TOP',
                      horizontalPositioning: 'CENTER',
                    },
                  },
                  opacity: 1,
                  children: [],
                  fontSize: 16,
                  autoWidth: false,
                  fontStyle: 'normal',
                  multiline: true,
                  fontFamily: '@body',
                  layoutText: [' NEW SALES'],
                  selectable: false,
                  positioning: 'fixed',
                  responsivity: {
                    verticalScaling: 'FIXED',
                    horizontalScaling: 'SCALES_WITH_PARENT',
                    verticalPositioning: 'TOP',
                    horizontalPositioning: 'CENTER',
                  },
                  initialDevice: 'desktop',
                  textAlignment: 'center',
                },
              ],
              pushGraph: {
                edges: [
                  {
                    distance: 4,
                    endNodeId: '61zllid8z6t7cthkp5zex5cb8',
                    startNodeId: '3adlpgk4i7v28rsnxli0po4yp',
                  },
                ],
                nodeIds: [
                  '3adlpgk4i7v28rsnxli0po4yp',
                  '61zllid8z6t7cthkp5zex5cb8',
                ],
              },
              borderColor: '#e0e0e0',
              borderStyle: 'solid',
              borderWidth: 1,
              positioning: 'fixedTop',
              borderRadius: 12,
              responsivity: {
                verticalScaling: 'FIXED',
                horizontalScaling: 'SCALES_WITH_PARENT',
                verticalPositioning: 'TOP',
                horizontalPositioning: 'CENTER',
              },
              initialDevice: 'desktop',
              borderPosition: 'center',
              backgroundColor: '@background',
              backgroundStyle: 'color',
            },
            {
              x: 408.00000000000347,
              y: 115.5,
              id: '6z6edi3x8sjpen0jgiidv1awb',
              name: 'Rectangle  37',
              type: 'section',
              width: 323.9999999999982,
              height: 144,
              hidden: false,
              mobile: {
                x: 798.3003742203762,
                y: 115.5,
                width: 620.3076923076941,
                height: 144,
                pushGraph: {
                  edges: [
                    {
                      distance: 3.5,
                      endNodeId: 'b4zjd07zwgkfncq3olhfw4cod',
                      startNodeId: '9odhh9mtlw43bzdnastudj873',
                    },
                  ],
                  nodeIds: [
                    '9odhh9mtlw43bzdnastudj873',
                    'b4zjd07zwgkfncq3olhfw4cod',
                  ],
                },
                positioning: 'fixedTop',
                responsivity: {
                  verticalScaling: 'FIXED',
                  horizontalScaling: 'SCALES_WITH_PARENT',
                  verticalPositioning: 'TOP',
                  horizontalPositioning: 'CENTER',
                },
              },
              shadow: {
                x: 0,
                y: 2,
                size: 4,
                color: 'rgba(0, 0, 0, 0.2)',
                enabled: true,
              },
              shared: {
                mobile: false,
                tablet: true,
                desktop: true,
              },
              tablet: {
                x: 490.8487653120773,
                y: 115.5,
                width: 246.86494264048065,
                height: 144,
                pushGraph: {
                  edges: [
                    {
                      distance: 6,
                      endNodeId: 'b4zjd07zwgkfncq3olhfw4cod',
                      startNodeId: '9odhh9mtlw43bzdnastudj873',
                    },
                  ],
                  nodeIds: [
                    '9odhh9mtlw43bzdnastudj873',
                    'b4zjd07zwgkfncq3olhfw4cod',
                  ],
                },
              },
              actions: {},
              desktop: {
                x: 523.2167162162184,
                y: 115.5,
                width: 216.72972972972843,
                height: 144,
                pushGraph: {
                  edges: [
                    {
                      distance: 4,
                      endNodeId: 'b4zjd07zwgkfncq3olhfw4cod',
                      startNodeId: '9odhh9mtlw43bzdnastudj873',
                    },
                  ],
                  nodeIds: [
                    '9odhh9mtlw43bzdnastudj873',
                    'b4zjd07zwgkfncq3olhfw4cod',
                  ],
                },
              },
              opacity: 1,
              children: [
                {
                  x: 422.5617977528126,
                  y: 161,
                  id: '9odhh9mtlw43bzdnastudj873',
                  name: null,
                  text: '$55,688',
                  type: 'label',
                  color: '@text',
                  width: 296.69662921348214,
                  height: 30,
                  hidden: false,
                  mobile: {
                    x: 826.1793716274666,
                    y: 161.5,
                    width: 568.0345721694044,
                    height: 30,
                    positioning: 'fixed',
                    responsivity: {
                      verticalScaling: 'FIXED',
                      horizontalScaling: 'SCALES_WITH_PARENT',
                      verticalPositioning: 'TOP',
                      horizontalPositioning: 'CENTER',
                    },
                  },
                  shared: {
                    mobile: false,
                    tablet: false,
                    desktop: false,
                  },
                  tablet: {
                    x: 501.94381891389565,
                    y: 160,
                    width: 226.06171713706965,
                    height: 30,
                    positioning: 'fixed',
                    responsivity: {
                      verticalScaling: 'FIXED',
                      horizontalScaling: 'SCALES_WITH_PARENT',
                      verticalPositioning: 'TOP',
                      horizontalPositioning: 'CENTER',
                    },
                  },
                  actions: {},
                  desktop: {
                    x: 532.9573782148101,
                    y: 161,
                    width: 198.46598846036943,
                    height: 30,
                    positioning: 'fixed',
                    responsivity: {
                      verticalScaling: 'FIXED',
                      horizontalScaling: 'SCALES_WITH_PARENT',
                      verticalPositioning: 'TOP',
                      horizontalPositioning: 'CENTER',
                    },
                  },
                  opacity: 1,
                  children: [],
                  fontSize: 26,
                  autoWidth: false,
                  fontStyle: 'normal',

                  multiline: true,
                  fontFamily: '@body',
                  layoutText: ['$55,688'],
                  selectable: false,
                  positioning: 'fixed',
                  responsivity: {
                    verticalScaling: 'FIXED',
                    horizontalScaling: 'SCALES_WITH_PARENT',
                    verticalPositioning: 'TOP',
                    horizontalPositioning: 'CENTER',
                  },
                  initialDevice: 'desktop',
                  textAlignment: 'center',
                  inResponsiveApp: true,
                  calculatedFontFamily:
                    '-apple-system, "SF Pro Text", sans-serif',
                },
                {
                  x: 437.6341463414681,
                  y: 195,
                  id: 'b4zjd07zwgkfncq3olhfw4cod',
                  name: null,
                  text: 'MRR ALL TIME',
                  type: 'label',
                  color: 'rgba(117, 117, 117, 1)',
                  width: 264.7317073170713,
                  height: 19,
                  hidden: false,
                  mobile: {
                    x: 811.9122129055777,
                    y: 195,
                    width: 592.011666059058,
                    height: 19,
                    positioning: 'fixed',
                    responsivity: {
                      verticalScaling: 'FIXED',
                      horizontalScaling: 'SCALES_WITH_PARENT',
                      verticalPositioning: 'TOP',
                      horizontalPositioning: 'CENTER',
                    },
                  },
                  shared: {
                    mobile: false,
                    tablet: false,
                    desktop: false,
                  },
                  tablet: {
                    x: 496.96753225291224,
                    y: 196,
                    width: 234.8561040906926,
                    height: 19,
                    positioning: 'fixed',
                    responsivity: {
                      verticalScaling: 'FIXED',
                      horizontalScaling: 'SCALES_WITH_PARENT',
                      verticalPositioning: 'TOP',
                      horizontalPositioning: 'CENTER',
                    },
                  },
                  actions: {},
                  desktop: {
                    x: 543.0395573383821,
                    y: 195,
                    width: 177.08404746209533,
                    height: 19,
                    positioning: 'fixed',
                    responsivity: {
                      verticalScaling: 'FIXED',
                      horizontalScaling: 'SCALES_WITH_PARENT',
                      verticalPositioning: 'TOP',
                      horizontalPositioning: 'CENTER',
                    },
                  },
                  opacity: 1,
                  children: [],
                  fontSize: 16,
                  autoWidth: false,
                  fontStyle: 'normal',

                  multiline: true,
                  fontFamily: '@body',
                  layoutText: ['MRR ALL TIME'],
                  selectable: false,
                  positioning: 'fixed',
                  responsivity: {
                    verticalScaling: 'FIXED',
                    horizontalScaling: 'SCALES_WITH_PARENT',
                    verticalPositioning: 'TOP',
                    horizontalPositioning: 'CENTER',
                  },
                  initialDevice: 'desktop',
                  textAlignment: 'center',
                },
              ],
              pushGraph: {
                edges: [
                  {
                    distance: 4,
                    endNodeId: 'b4zjd07zwgkfncq3olhfw4cod',
                    startNodeId: '9odhh9mtlw43bzdnastudj873',
                  },
                ],
                nodeIds: [
                  '9odhh9mtlw43bzdnastudj873',
                  'b4zjd07zwgkfncq3olhfw4cod',
                ],
              },
              borderColor: '#e0e0e0',
              borderStyle: 'solid',
              borderWidth: 1,
              positioning: 'fixedTop',
              borderRadius: 12,
              responsivity: {
                verticalScaling: 'FIXED',
                horizontalScaling: 'SCALES_WITH_PARENT',
                verticalPositioning: 'TOP',
                horizontalPositioning: 'CENTER',
              },
              initialDevice: 'desktop',
              borderPosition: 'center',
              backgroundColor: '@background',
              backgroundStyle: 'color',
            },
            {
              x: 1145.9999999999995,
              y: 115.5,
              id: 'efu7hue18uz8e01fsb2pvifem',
              name: 'Rectangle  38',
              type: 'section',
              width: 323.9999999999968,
              height: 144,
              hidden: false,
              mobile: {
                x: 799.9559251559286,
                y: 271,
                width: 620.3076923076878,
                height: 144,
                pushGraph: {
                  edges: [
                    {
                      distance: 29,
                      endNodeId: '6qozdq29m27ad6r6fhqhqsrqw',
                      startNodeId: 'buffer_6qozdq29m27ad6r6fhqhqsrqw',
                    },
                  ],
                  nodeIds: [
                    'a3kz9cg4e16xgalt7yiarwrqk',
                    'buffer_6qozdq29m27ad6r6fhqhqsrqw',
                    '6qozdq29m27ad6r6fhqhqsrqw',
                  ],
                },
                positioning: 'fixed',
                responsivity: {
                  verticalScaling: 'FIXED',
                  horizontalScaling: 'SCALES_WITH_PARENT',
                  verticalPositioning: 'TOP',
                  horizontalPositioning: 'CENTER',
                },
              },
              shadow: {
                x: 0,
                y: 2,
                size: 4,
                color: 'rgba(0, 0, 0, 0.2)',
                enabled: true,
              },
              shared: {
                mobile: false,
                tablet: false,
                desktop: false,
              },
              tablet: {
                x: 1052.2925733601705,
                y: 116,
                width: 247.49144363025448,
                height: 144,
                pushGraph: {
                  edges: [
                    {
                      distance: 2.5,
                      endNodeId: '6qozdq29m27ad6r6fhqhqsrqw',
                      startNodeId: 'a3kz9cg4e16xgalt7yiarwrqk',
                    },
                  ],
                  nodeIds: [
                    'a3kz9cg4e16xgalt7yiarwrqk',
                    '6qozdq29m27ad6r6fhqhqsrqw',
                  ],
                },
                positioning: 'fixedTop',
                responsivity: {
                  verticalScaling: 'FIXED',
                  horizontalScaling: 'SCALES_WITH_PARENT',
                  verticalPositioning: 'TOP',
                  horizontalPositioning: 'CENTER',
                },
              },
              actions: {},
              desktop: {
                x: 1016.8788783696311,
                y: 115.5,
                width: 216.72972972973275,
                height: 144,
                pushGraph: {
                  edges: [
                    {
                      distance: 0,
                      endNodeId: '6qozdq29m27ad6r6fhqhqsrqw',
                      startNodeId: 'a3kz9cg4e16xgalt7yiarwrqk',
                    },
                  ],
                  nodeIds: [
                    'a3kz9cg4e16xgalt7yiarwrqk',
                    '6qozdq29m27ad6r6fhqhqsrqw',
                  ],
                },
                positioning: 'fixedTop',
                responsivity: {
                  verticalScaling: 'FIXED',
                  horizontalScaling: 'SCALES_WITH_PARENT',
                  verticalPositioning: 'TOP',
                  horizontalPositioning: 'CENTER',
                },
              },
              opacity: 1,
              children: [
                {
                  x: 1160.561797752803,
                  y: 163,
                  id: 'a3kz9cg4e16xgalt7yiarwrqk',
                  name: null,
                  text: '700',
                  type: 'label',
                  color: '@text',
                  width: 296.69662921348026,
                  height: 30,
                  hidden: false,
                  mobile: {
                    x: 827.8349225630203,
                    y: 319,
                    width: 568.0345721693978,
                    height: 30,
                    positioning: 'fixed',
                    responsivity: {
                      verticalScaling: 'FIXED',
                      horizontalScaling: 'SCALES_WITH_PARENT',
                      verticalPositioning: 'TOP',
                      horizontalPositioning: 'CENTER',
                    },
                  },
                  shared: {
                    mobile: false,
                    tablet: false,
                    desktop: false,
                  },
                  tablet: {
                    x: 1063.4157843098474,
                    y: 162.5,
                    width: 226.63542309961332,
                    height: 30,
                    positioning: 'fixed',
                    responsivity: {
                      verticalScaling: 'FIXED',
                      horizontalScaling: 'SCALES_WITH_PARENT',
                      verticalPositioning: 'TOP',
                      horizontalPositioning: 'CENTER',
                    },
                  },
                  actions: {},
                  desktop: {
                    x: 1026.6195403682232,
                    y: 163,
                    width: 198.46598846037344,
                    height: 30,
                    positioning: 'fixed',
                    responsivity: {
                      verticalScaling: 'FIXED',
                      horizontalScaling: 'SCALES_WITH_PARENT',
                      verticalPositioning: 'TOP',
                      horizontalPositioning: 'CENTER',
                    },
                  },
                  opacity: 1,
                  children: [],
                  fontSize: 26,
                  autoWidth: false,
                  fontStyle: 'normal',

                  multiline: true,
                  fontFamily: '@body',
                  layoutText: ['700'],
                  selectable: false,
                  positioning: 'fixed',
                  responsivity: {
                    verticalScaling: 'FIXED',
                    horizontalScaling: 'SCALES_WITH_PARENT',
                    verticalPositioning: 'TOP',
                    horizontalPositioning: 'CENTER',
                  },
                  initialDevice: 'desktop',
                  textAlignment: 'center',
                  inResponsiveApp: true,
                  calculatedFontFamily:
                    '-apple-system, "SF Pro Text", sans-serif',
                },
                {
                  x: 1175.6341463414617,
                  y: 190,
                  id: '6qozdq29m27ad6r6fhqhqsrqw',
                  name: null,
                  text: 'ALL TIME',
                  type: 'label',
                  color: 'rgba(117, 117, 117, 1)',
                  width: 264.731707317071,
                  height: 19,
                  hidden: false,
                  mobile: {
                    x: 818.4901203062348,
                    y: 348,
                    width: 582.144804958076,
                    height: 19,
                    positioning: 'fixed',
                    responsivity: {
                      verticalScaling: 'FIXED',
                      horizontalScaling: 'SCALES_WITH_PARENT',
                      verticalPositioning: 'TOP',
                      horizontalPositioning: 'CENTER',
                    },
                  },
                  shared: {
                    mobile: false,
                    tablet: false,
                    desktop: false,
                  },
                  tablet: {
                    x: 1059.9314288232504,
                    y: 195,
                    width: 233.12922097237933,
                    height: 19,
                    positioning: 'fixed',
                    responsivity: {
                      verticalScaling: 'FIXED',
                      horizontalScaling: 'SCALES_WITH_PARENT',
                      verticalPositioning: 'TOP',
                      horizontalPositioning: 'CENTER',
                    },
                  },
                  actions: {},
                  desktop: {
                    x: 1036.7017194917946,
                    y: 193,
                    width: 177.08404746209834,
                    height: 19,
                    positioning: 'fixed',
                    responsivity: {
                      verticalScaling: 'FIXED',
                      horizontalScaling: 'SCALES_WITH_PARENT',
                      verticalPositioning: 'TOP',
                      horizontalPositioning: 'CENTER',
                    },
                  },
                  opacity: 1,
                  children: [],
                  fontSize: 16,
                  autoWidth: false,
                  fontStyle: 'normal',

                  multiline: true,
                  fontFamily: '@body',
                  layoutText: ['ALL TIME'],
                  selectable: false,
                  positioning: 'fixed',
                  responsivity: {
                    verticalScaling: 'FIXED',
                    horizontalScaling: 'SCALES_WITH_PARENT',
                    verticalPositioning: 'TOP',
                    horizontalPositioning: 'CENTER',
                  },
                  initialDevice: 'desktop',
                  textAlignment: 'center',
                  inResponsiveApp: true,
                  calculatedFontFamily:
                    '-apple-system, "SF Pro Text", sans-serif',
                },
              ],
              pushGraph: {
                edges: [
                  {
                    distance: 27,
                    endNodeId: '6qozdq29m27ad6r6fhqhqsrqw',
                    startNodeId: 'buffer_6qozdq29m27ad6r6fhqhqsrqw',
                  },
                ],
                nodeIds: [
                  'a3kz9cg4e16xgalt7yiarwrqk',
                  'buffer_6qozdq29m27ad6r6fhqhqsrqw',
                  '6qozdq29m27ad6r6fhqhqsrqw',
                ],
              },
              borderColor: '#e0e0e0',
              borderStyle: 'solid',
              borderWidth: 1,
              positioning: 'fixedTop',
              borderRadius: 12,
              responsivity: {
                verticalScaling: 'FIXED',
                horizontalScaling: 'SCALES_WITH_PARENT',
                verticalPositioning: 'TOP',
                horizontalPositioning: 'CENTER',
              },
              initialDevice: 'desktop',
              borderPosition: 'center',
              backgroundColor: '@background',
              backgroundStyle: 'color',
            },
            {
              x: 42.00000000000365,
              y: 51,
              id: '0nmnql1vsm1u9ydvm78je8l5j',
              name: null,
              text: 'Dashboard',
              type: 'label',
              color: '@text',
              width: 1427.9999999999945,
              height: 38,
              hidden: false,
              mobile: {
                x: 86.41347193347548,
                y: 51,
                width: 1339.173056133051,
                height: 38,
              },
              shared: {
                mobile: true,
                tablet: true,
                desktop: true,
              },
              tablet: {
                x: 211.98281158856975,
                y: 51,
                width: 1088.0343768228618,
                height: 38,
              },
              actions: {},
              desktop: {
                x: 278.3923918918942,
                y: 51,
                width: 955.2162162162127,
                height: 38,
              },
              opacity: 1,
              children: [],
              fontSize: 33,
              autoWidth: false,
              fontStyle: 'normal',

              multiline: true,
              fontFamily: '@body',
              layoutText: ['Dashboard'],
              selectable: false,
              positioning: 'fixedTop',
              responsivity: {
                verticalScaling: 'FIXED',
                horizontalScaling: 'SCALES_WITH_PARENT',
                verticalPositioning: 'TOP',
                horizontalPositioning: 'CENTER',
              },
              initialDevice: 'desktop',
              textAlignment: 'left',
            },
          ],
          pushGraph: {
            edges: [
              {
                distance: 26.5,
                endNodeId: '88eyvwcazd6dw11ayr35eg05u',
                startNodeId: '0nmnql1vsm1u9ydvm78je8l5j',
              },
              {
                distance: 26.5,
                endNodeId: '7i34i49qwjekuf6qg9894q5ld',
                startNodeId: '0nmnql1vsm1u9ydvm78je8l5j',
              },
              {
                distance: 26.5,
                endNodeId: '6z6edi3x8sjpen0jgiidv1awb',
                startNodeId: '0nmnql1vsm1u9ydvm78je8l5j',
              },
              {
                distance: 26.5,
                endNodeId: 'efu7hue18uz8e01fsb2pvifem',
                startNodeId: '0nmnql1vsm1u9ydvm78je8l5j',
              },
            ],
            nodeIds: [
              '0nmnql1vsm1u9ydvm78je8l5j',
              '88eyvwcazd6dw11ayr35eg05u',
              '7i34i49qwjekuf6qg9894q5ld',
              '6z6edi3x8sjpen0jgiidv1awb',
              'efu7hue18uz8e01fsb2pvifem',
            ],
          },
          borderColor: '#e0e0e0',
          borderStyle: 'none',
          borderWidth: 1,
          positioning: 'fixed',
          borderRadius: 10,
          responsivity: {
            verticalScaling: 'FIXED',
            horizontalScaling: 'SCALES_WITH_PARENT',
            verticalPositioning: 'TOP',
            horizontalPositioning: 'LEFT_AND_RIGHT',
          },
          initialDevice: 'desktop',
          borderPosition: 'center',
          backgroundColor: '#f5f5f5',
          backgroundStyle: 'none',
        },
      ],
      pushGraph: {
        edges: [],
        nodeIds: ['9d8gljssqqz83i5zeg2wwrp91'],
      },
      borderColor: '#BDBDBD',
      borderStyle: 'none',
      borderWidth: 1,
      positioning: 'fixed',
      borderRadius: 0,
      responsivity: {
        verticalScaling: 'FIXED',
        horizontalScaling: 'SCALES_WITH_PARENT',
        verticalPositioning: 'TOP',
        horizontalPositioning: 'CENTER',
      },
      initialDevice: 'desktop',
      borderPosition: 'center',
      backgroundColor: '#e0e0e0',
      backgroundStyle: 'none',
    },
  ],
  pushGraph: {
    edges: [],
    nodeIds: ['6d0gng1qpvhk2hkyfyq4ru57l'],
  },
  borderColor: '#e0e0e0',
  borderStyle: 'none',
  borderWidth: 1,
  imageResize: 'cover',
  positioning: 'fixedTop',
  borderRadius: 0,
  responsivity: {
    verticalScaling: 'FIXED',
    horizontalScaling: 'SCALES_WITH_PARENT',
    verticalPositioning: 'TOP',
    horizontalPositioning: 'CENTER',
  },
  initialDevice: 'desktop',
  snappingRules: {
    lock: {
      left: 0,
      right: 0,
    },
    snap: true,
    snapType: 'screenEdge',
  },
  borderPosition: 'center',
  backgroundColor: '@background',
  backgroundStyle: 'none',
}

export default dashboardMetricBoxes
